import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Waypoint } from 'react-waypoint';
import { Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIfetchUserActions } from '../../api/User';

import UserProfileActionsItem from './ActionsItem';

import Loading from '../Loading';
import NothingFound from '../NothingFound';

const UserProfileActions = ({ profile }) => {
  const intl = useIntl();

  const [actions, setActions] = useState([]);
  const [actionsLoading, setActionsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [end, setEnd] = useState(false);

  const loadMore = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    if (end) {
      return;
    }

    setActionsLoading(true);
    APIfetchUserActions(profile.uuid, { page }).then((response) => {
      const { data } = response;
      if (page === 1) {
        setActions(data.data);
      } else {
        setActions(prevActions => [...prevActions, ...data.data]);
      }
      if (data.meta.current_page >= data.meta.last_page) {
        setEnd(true);
      }
    }).catch(() => {
      setActions([]);
    }).finally(() => {
      setActionsLoading(false);
    });
  }, [profile.uuid, page, end]);

  return (
    <div className="user-profile-actions">
      <div className="user-profile-actions-header">
        <h4>{intl.formatMessage({ defaultMessage: 'User Activity' })}</h4>
      </div>
      {actions.length > 0 ? (
        <Table className="user-profile-actions-list" responsive>
          <tbody>
            {actions.map(action => (
              <UserProfileActionsItem
                key={action.id}
                action={action}
                profile={profile}
              />
            ))}
          </tbody>
        </Table>
      ) : (
        <>
          {!actionsLoading && (
            <NothingFound text={intl.formatMessage({ defaultMessage: 'Nothing found yet' })} />
          )}
        </>
      )}
      {actionsLoading ? (
        <Loading />
      ) : (
        <Waypoint
          bottomOffset="-50px"
          onEnter={() => { loadMore(); }}
        />
      )}
    </div>
  );
};

UserProfileActions.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default UserProfileActions;
